module.exports = __webpack_public_path__ + "static/img/200.2a95218d.png";